import React from 'react';
import { IMAGES } from '../data';
import { Reveal } from './Reveal';
export function Philosophy() {
  return <section id="filosofi" className="w-full bg-warm py-28 md:py-40" data-id="element-164" data-mp="3dwvse2kn9f9c">
      {/* Varumärke — intro statement */}
      <div className="mx-auto max-w-4xl px-6 text-center md:px-10" data-id="element-165" data-mp="305r23r361zbo">
        <Reveal data-id="element-166" data-mp="3553knzn08k8g">
          <p className="mb-8 text-[12px] uppercase tracking-wide3 text-terrakotta" data-id="element-167" data-mp="354lkirx81lv9">Smaken som Baken</p>
        </Reveal>
        <Reveal delay={0.1} data-id="element-168" data-mp="2q6t6k47bp5j6">
          <h2 className="font-display text-3xl font-light leading-tight text-brun sm:text-4xl md:text-5xl" data-id="element-169" data-mp="2qapbsrx5mr7i">
            Smålands smaker samlade på ett och samma ställe för dig som vill hitta det bästa!
          </h2>
        </Reveal>
        <Reveal delay={0.2} data-id="element-170" data-mp="2m5zgp5ablgnn">
          <div className="mt-10 flex flex-wrap justify-center gap-4" data-id="element-171" data-mp="2m7ave05b08tj">
            <a href="/utbud" className="inline-block rounded-full bg-skog px-8 py-3 text-sm uppercase tracking-wide2 text-warm transition-colors hover:bg-brun" data-id="element-172" data-mp="fg1plkpxqpm5">
              Se utbud
            </a>
            <a href="/bestall" className="inline-block rounded-full border border-brun/20 px-8 py-3 text-sm uppercase tracking-wide2 text-brun transition-colors hover:bg-brun hover:text-warm" data-id="element-173" data-mp="17amg56lkpgir">
              Gör en förfrågan
            </a>
          </div>
        </Reveal>
      </div>

      {/* Vår filosofi — image + copy */}
      <div className="mx-auto mt-28 grid max-w-7xl items-center gap-12 px-6 md:mt-40 md:grid-cols-2 md:gap-20 md:px-10" data-id="element-174" data-mp="1c2o25k8jmllz">
        <Reveal className="order-2 md:order-1" data-id="element-175" data-mp="oemnruoooayn">
          <p className="mb-6 text-[12px] uppercase tracking-wide3 text-terrakotta" data-id="element-176" data-mp="kbqc6nxk9f47">Vår filosofi</p>
          <h3 className="font-display text-3xl font-light leading-tight text-brun md:text-4xl" data-id="element-177" data-mp="yazp9eqgzt3y">
            Mat sätter stämningen.
          </h3>
          <div className="mt-8 space-y-4 text-lg leading-relaxed text-brun-soft" data-id="element-178" data-mp="tdpt7g8ksj75">
            <p data-id="element-179" data-mp="29obnna3gnjiq">
              Den lyfter en konferens, gör bröllopet minnesvärt och får gäster att stanna längre. Därför väljer vi våra partners med extrem omsorg.
            </p>
          </div>
          <p className="mt-8 font-display text-xl italic text-bourgogne md:text-2xl" data-id="element-180" data-mp="2cqy9awdyky5h">
            Här hittar du inte det billigaste. Du hittar det bästa.
          </p>
        </Reveal>

        <Reveal delay={0.15} className="order-1 md:order-2" data-id="element-181" data-mp="2lt7jtm988riv">
          <div className="grid grid-cols-5 gap-4" data-id="element-182" data-mp="2qr0na7j5b7fg">
            <div className="col-span-3 overflow-hidden rounded-sm" data-id="element-183" data-mp="2qqqw4gmd6u86">
              <img src={IMAGES.bakerSourdough} alt="Bagares mjöliga händer skär ett surdegsbröd" className="h-full w-full object-cover" data-id="element-184" data-mp="1t4a0rgx6yqp2" />
            </div>
            <div className="col-span-2 mt-10 overflow-hidden rounded-sm" data-id="element-185" data-mp="230wjo05yj7og">
              <img src={IMAGES.coffeeSteam} alt="Ånga stiger från en kopp nybryggt kaffe" className="h-full w-full object-cover" data-id="element-186" data-mp="27swski409ax6" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}